import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginService } from 'src/app/accountancy/authentication/login/login-service/login.service';
import { HttpApiService } from 'src/app/accountancy/utilities/services/http-api/http-api.service';

@Injectable({
  providedIn: 'root'
})
export class DisbursementVoucherService {

  constructor(
    private _api: HttpApiService,
    private _loginS: LoginService,
  ) { }

  public generateVoucher(body: Omit<VoucherInterface, "VoucherItems">) {
    return this._api.sendPostRequest<HttpResponse<any>>(
      `/api/v1/disbursement-voucher`,
      body,
      this._loginS.getTokenHeader,
    );
  }

  public addVoucherItem(body: VoucherItemAddInterface[]) {
    return this._api.sendPostRequest<HttpResponse<any>>(
      '/api/v1/disbursement-voucher/items',
      { Items: body },
      this._loginS.getTokenHeader,
    );
  }

}

export type DisbursementType = "Reimbursement" | "Cash Advance" | "Liquidation";

export interface VoucherInterface {
  Type: DisbursementType;
  CntrlNumber: string;
  PayToTheOrder0f: string;
  Payee: string;
  Amount: number;
  Particulars: string;
  VATReg: number;
  VoucherItems: VoucherItemInterface[];
}

export interface VoucherItemInterface {
  AccountCode: string;
  Description: string;
  SubAccount: string;
  Debit: number;
  Credit: number;
}

export interface VoucherItemAddInterface {
  ReferenceId: string;
  Type: "R" | "L" | "CA";
  Account: string;
  Description: string;
  SubAccount: string;
  Debit: number;
  Credit: number;
}